import { render, staticRenderFns } from "./_nav-menu.vue?vue&type=template&id=4c1472ff&scoped=true&"
import script from "./_nav-menu.vue?vue&type=script&lang=js&"
export * from "./_nav-menu.vue?vue&type=script&lang=js&"
import style0 from "./_nav-menu.vue?vue&type=style&index=0&id=4c1472ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1472ff",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
installComponents(component, {VDivider,VIcon,VList,VListItem,VListItemContent,VListItemGroup})
